import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import './style.css';

import BlogsSection from '../../Components/BlogsSection';
// import GetInTouchSection from '../../Components/GetInTouchSection';
// import StayConnected from '../../Components/StayConnectedSection';

// Blog images
import P_1 from '../../assets/images/Project1.webp';
import P_2 from '../../assets/images/Project2.webp';
import P_3 from '../../assets/images/Project3.webp';
import P_4 from '../../assets/images/Project4.webp';
import P_5 from '../../assets/images/Project5.webp';
import P_6 from '../../assets/images/Project6.webp';

export default function Blogs() {
  const location = useLocation();
  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;
  
  const blogs = [
    {
      name: 'Blog',
      date: '25 March, 2025',
      image: P_1,
      link: '',
    },
    {
      name: 'Blog',
      date: '23 March, 2025',
      image: P_2,
      link: '',
    },
    {
      name: 'Blog',
      date: '21 March, 2025',
      image: P_3,
      link: '',
    },
    {
      name: 'Blog',
      date: '24 March, 2025',
      image: P_4,
      link: '',
    },
    {
      name: 'Blog',
      date: '22 March, 2025',
      image: P_5,
      link: '',
    },
    {
      name: 'Blog',
      date: '20 March, 2025',
      image: P_6,
      link: '',
    },
  ];

  return (
    <div className='blogs-page'>
      <Helmet>
        <title>Starlife: News and Blog</title>
        <meta
          name='description'
          content='Stay updated with Starlife Group’s latest news, real estate insights, investment trends, and project announcements.'
        />
        <meta
          name='keywords'
          content='Starlife blog, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>

      <BlogsSection blogs={blogs} />
      {/* <GetInTouchSection /> */}
      {/* <StayConnected /> */}
    </div>
  );
}
